<template>
  <div>
    <div class="landing-page b-container fluid vh-100 d-flex justify-content-center align-items-center"
      :class="gradientColor">
      <div class="outer-div overflow-hidden">
        <div class="row align-items-center h-100 mx-3 rounded" :class="gradientColor">
          <div class="welcome1 h-100 col-lg-6 col-md-12  p-0 overflow-auto bg-white rounded-left ">
            <div class="mx-2 h-50 bg-white d-flex align-items-center ">
              <div class="h-auto ml-5">
                <h1 class="mb-4 display-3">Welcome back, <span class="d-inline-block font-weight-bold"
                    :class="textColor">{{ userName }}</span>!</h1>
                <p class="textBlack" v-if="recentActivities.length <= 0">No recent activities.</p>
                <p class="textBlack" v-else>Here are your recent activities:</p>
                <ul>
                  <li v-for="(user_activity, index) in recentActivities" :key="index" :class="textColor">
                    <span class="textBlack">{{ user_activity.activity.action }} </span>

                    <span
                      v-if="user_activity.activity.category == 'Documents' || user_activity.activity.category == 'Sales Channel Management' || user_activity.activity.category == 'Sales Channel Promotions' || user_activity.activity.category == 'Purchase to Payment'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'Master Data Management'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'Reports'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'POS Settings'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'User Management'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'MMS Configuration Settings'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'My Wavelets'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                    <span v-else-if="user_activity.activity.category == 'My Apps'">
                      <router-link :to="user_activity.site" :class="textColor"> {{ user_activity.activity.system_module }}
                      </router-link>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            
            <a-spin :spinning="spinner" :tip="spinner_tip">
            <div v-if="alertDatas.length > 0" class="mb-12 bg-white align-items-center" style="min-height: 20vh; padding: 15px;">
              <h3 class="mb-4 display-5" style="margin-left: 20px; margin-bottom: 0px !important;"><i class="fa fa-bell"></i> System Alerts and Reminders</h3>
              <div class="col-md-4 d-inline-block" v-for="alertData in alertDatas" :key="alertData.key">
                <a-card hoverable @click="generateReminderCsv(alertData.data, alertData.details['name']);" style="cursor:pointer; margin-top: 10px; background: #F7F7F7;">
                    <a-statistic
                      :title="alertData.details['name']"
                      :value="alertData.data.length"
                      :precision="alertData.details['alert_styles'].precision"
                      :suffix="alertData.details['alert_styles'].suffix"
                      :value-style="{ color: alertData.details['alert_styles'].icon_color }"
                    >
                      <template #prefix>
                        <a-icon :type="alertData.details['alert_styles'].icon_type" :theme="alertData.details['alert_styles'].icon_theme" :two-tone-color="alertData.details['alert_styles'].icon_color" />
                      </template>
                    </a-statistic>
                  </a-card>
              </div>
            </div>
          </a-spin>
          </div>
          
          <div class="col-lg-6 col-md-12 h-100  p-0">
            <div class="welcome2 h-100 mx-2 rounded-right" :style="bgImage"></div>
          </div>
        </div>
      </div>
    </div>
    <releases/>

    <!-- Reminders modal -->
    <a-modal :title="reminderModalTitle" :visible="reminderModal" :maskClosable = "false"
            @cancel="reminderModal = false;" width='70%' wrap-class-name="full-modal">
        <template slot="footer">
            <button class="btn btn-success btn-sm align-bottom" @click.prevent="exportDataToCSV">Export to CSV</button>
            <button class="btn btn-sm align-bottom" key="back" @click="reminderModal = false;">Close</button>
        </template>
        <a-table rowKey='id' :columns="reminderColumns" :dataSource="reminderData" :pagination="true" size="small">
          <template slot="print-ecom-si" slot-scope="s3_link, record">
            <div>
              <a-button type="primary" @click.prevent="printSI(record)">
                Print
              </a-button>
            </div>
          </template>
        </a-table>
    </a-modal>
  </div>
</template>

<script>
import secureStorage from '../controllers/secureStorage.js'
import Releases from './Releases.vue'
import { mapState } from 'vuex'
import HTTPRequest from '../controllers/httpRequest.js'
import Papa from "papaparse";
// import Releases from './Releases.vue'

const getNotificationStyle = type => {
        return {
            success: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            warning: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffe58f',
                backgroundColor: '#fffbe6'
            },
            error: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            info: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #91d5ff',
                backgroundColor: '#e6f7ff'
            }
        }[type]
    }

export default {
  computed: {
    ...mapState(["endPoint", "validSites"]),
    bgImage() {
      return `background-image: url(${require("../assets/background/" + this.businessTypeCode + "/instore.png")})`;
    },
    gradientColor() {
      if (this.businessTypeCode == "SUP") {
        return "bg-sup";
      }
      else if (this.businessTypeCode == "FNB") {
        return "bg-fnb";
      }
      else if (this.businessTypeCode == "BOU") {
        return "bg-bou";
      }
      else if (this.businessTypeCode == "DRU") {
        return "bg-dru";
      }
      else if (this.businessTypeCode == "HIM") {
        return "bg-him";
      }
    },
    textColor() {
      if (this.businessTypeCode == "SUP") {
        return "text-sup";
      }
      else if (this.businessTypeCode == "FNB") {
        return "text-fnb";
      }
      else if (this.businessTypeCode == "BOU") {
        return "text-bou";
      }
      else if (this.businessTypeCode == "DRU") {
        return "text-dru";
      }
      else if (this.businessTypeCode == "HIM") {
        return "text-him";
      }
    }
  },
  mounted: async function () {
    var userId = secureStorage.getItem("userId");
    var user_activities = await HTTPRequest.getRequest(this.endPoint + "user_activities?user_id=" + userId, null);
    this.recentActivities = user_activities;
    this.userAlerts = secureStorage.getItem('userAlerts');
    var credentials = await this.getCachedAccountSettings()
    this.accountAlerts = JSON.parse(credentials.value)
    this.system_alerts = await HTTPRequest.getRequest(this.endPoint + 'settings/get_alerts' , null)
    for (const [key, value] of Object.entries(this.userAlerts)) {
      if(value == true){
        this.getAlertDetails(key);
      }
    }
  },
  data() {
    return {
      reminderColumns: [],
      reminderData: [],
      reminderModalTitle: "",
      reminderModal: false,
      system_alerts:{'alerts': []},
      businessTypeCode: JSON.parse(localStorage.getItem("businessTypeCode")),
      userName: secureStorage.getItem("userName"),
      recentActivities: [],
      baseURL: window.location.origin,
      userAlerts: [],
      accountAlerts: [],
      zeroCostItems: 0,
      zeroPriceItems: 0,
      retailPriceBelowLandedCost: 0,
      negativeOrZeroInventory: 0,
      lowStockItems: 0,
      overStockItems: 0,
      pendingDocuments: 0,
      intransitDocuments: 0,
      alertDatas: [],
      spinner: false,
      spinner_tip: "Loading Reminders..."
    };
  },
  components: { Releases },
  methods: {
    async getCachedAccountSettings() {
      var cacheKey = `accountSettings_${secureStorage.getItem("accountId")}`
      var cachedAccountSettings = secureStorage.getItem(cacheKey)
      if (cachedAccountSettings) return cachedAccountSettings

      var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
      if (credentials) secureStorage.setItem(cacheKey, credentials)
      return credentials
    },
    async printSI(data){
      this.spinner = true;
      window.open(data['s3_link']+data['receipt_details']+'.pdf','_blank');
      
      //Update pos documents is_printed
      var tagAsPrinted = await HTTPRequest.postRequest(this.endPoint + 'pos_documents/tag_as_printed?id='+data['id']+'&document_id='+data['ecom_document_id'], null);
      if(tagAsPrinted['error'] == undefined){
        this.$notification['success']({
                message: "Success",
                duration: 5,
                description: tagAsPrinted['msg'],
                style: getNotificationStyle('success')
        });
      } else {
        this.$notification['error']({
                message: "Error",
                duration: 5,
                description: tagAsPrinted['error'],
                style: getNotificationStyle('error')
        });
      }
      this.spinner = false;
    },
    exportDataToCSV(){
      const columns = Object.keys(this.reminderData[0])
      const csvdata = this.reminderData;

        var blob = new Blob([Papa.unparse(csvdata, { columns: columns, header: true})], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", this.reminderModalTitle+'.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$notification['success']({
                message: "Importing to CSV",
                duration: 5,
                description: "Data has been exported to CSV.",
                style: getNotificationStyle('error')
        });

    },
    generateReminderCsv(data, name){
      if(data.length == 0){
        this.$notification['error']({
                message: "Ooops!",
                duration: 5,
                description: "No data for " + name + ".",
                style: getNotificationStyle('error')
        });
        return;
      }

      this.reminderColumns = [];
      this.reminderData = data;
      let i = 0
      for (i in Object.keys(data[0])) {
        if (Object.keys(data[0])[i] == 'id') {
          this.reminderColumns.push({
            title: _.startCase(Object.keys(data[0])[i]),
            dataIndex: Object.keys(data[0])[i],
            key: 'id',
            sorter: (a, b) => a.id - b.id,
            sortDirections: ['descend', 'ascend'],
            defaultSortOrder: 'descend'
          })
        } else {
          if (Object.keys(data[0])[i] == 's3_link') {
            this.reminderColumns.push({
              title: 'Action',
              dataIndex: Object.keys(data[0])[i],
              scopedSlots: { customRender: "print-ecom-si" }
            })
          } else {
            this.reminderColumns.push({
              title: _.startCase(Object.keys(data[0])[i]),
              dataIndex: Object.keys(data[0])[i]
            })
          }
        }
      }
      this.reminderModalTitle = name;
      this.reminderModal = true;
    },
    async getAlertDetails(code) {
        var alertDetails = []
        alertDetails = this.system_alerts['alerts'].find(x => x.code === code)
        var alertPayload = {
          alertDetails: alertDetails,
          userId: secureStorage.getItem("userId"),
          userSites: secureStorage.getItem("userSites").map(a => a.id)
        }

        this.spinner = true;
        //Run query to backend
        if(typeof alertDetails != 'undefined'){
          var res_alert = await HTTPRequest.postRequest(this.endPoint + 'settings/process_query_alerts', null, alertPayload);
          this.alertDatas.push({
            id: alertDetails['id'],
            details: alertDetails,
            data: res_alert
          })
          this.spinner = false;
        }
        return;   
    }
  }
}
</script>

<style scoped>
.outer-div {
  height: 60%;
  width: 100%;
}

ul {
  margin-left: -20px;
}

.textBlack {
  color: #32325d;
}

.bg-sup {
  background: linear-gradient(89deg, #4AC9F1, #297BF3);
}

.bg-fnb {
  background: linear-gradient(89deg, #F4AB31, #F0653A);
}

.bg-bou {
  background: linear-gradient(89deg, #B453D3, #6636DD);
}

.bg-dru {
  background: linear-gradient(89deg, #57CD88, #56CFCB);
}

.bg-him {
  background: linear-gradient(89deg, #EA5B31, #E93559);
}

li.text-sup::marker,
.text-sup {
  color: #297BF3;
}

li.text-fnb::marker,
.text-fnb {
  color: #F0653A;
}

li.text-bou::marker,
.text-bou {
  color: #6636DD;
}

li.text-dru::marker,
.text-dru {
  color: #56CFCB;
}

li.text-him::marker,
.text-him {
  color: #E93559;
}

.welcome2 {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}</style>
